import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IClubSelectorBuilder from "../../../toolkit/baseForms2Commons/iClubSelectorBuilder/IClubSelectorBuilder";

export type Inputs = "idClub";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idClub",
      label: "Club",
      bts: {
        mCol: 3
      },
      component: IClubSelectorBuilder,
      props: {
        emptyLabel: "Todos los clubes",
        useSessionClub: true
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder,
      props: {
        color: "primary"
      }
    }
  ],
  validations: {},
  rows: [["idClub", "buscar"]]
};
